import styled from 'styled-components';
import { colors, spacing, subtitle2, Caption } from 'ui/theme';

// Filters
export const Sub2Span = styled.span`
  ${subtitle2}
`;

export const GrayCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const CombinatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
